import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ReadMoreComponentDef } from '@df/ui/display/read-more.component.def';
import { TranslationModule } from '@df/ui/translation/translation.module';
@Component({
    selector: 'read-more',
    template: `<div>
        @if (begining && !isMoreVisible) {
            <span [innerHtml]="begining + (hideDots ? ' ' : '...')"></span>
        }
        @if (!begining && !isMoreVisible) {
            <span [innerHtml]="text"></span>
        }
        <!-- empty a tag here, will be changed in the future, when functionality of this will be described -->
        @if (!isMoreVisible && begining) {
            <div [ngClass]="inline ? 'inline' : 'block'">
                <button [ngClass]="buttonStyle || 'button-inline'" (click)="toggle()">
                    <span>{{ 'Read more' | translate }}</span>
                </button>
            </div>
        }
        @if (isMoreVisible) {
            <span [innerHtml]="text + ' '"></span>
        }
        @if (isMoreVisible && readLess) {
            <div [ngClass]="inline ? 'inline' : 'block'">
                <button [ngClass]="buttonStyle || 'button-inline'" (click)="toggle()">
                    <span>{{ 'Read less' | translate }}</span>
                </button>
            </div>
        }
    </div>`,
    standalone: true,
    imports: [NgClass, TranslationModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReadMoreComponent extends ReadMoreComponentDef {
    /**
     * Read less CTA
     */
    @Input()
    readLess?: boolean = false;
    @Input()
    hideDots?: boolean;
    @Input()
    inline?: boolean;

    @Input()
    buttonStyle?: string;

    override toggle(to = !this.isMoreVisible): void {
        this.timeoutService.setTimeout(() => {
            this.isMoreVisible = to;
            this.changeDetectorRef.detectChanges();
        }, 50);
    }
}
